var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-nav',{attrs:{"tabs":""}},[_c('b-nav-item',{attrs:{"router-link":"","to":"transportation"}},[_c('icon',{attrs:{"name":"truck"}}),_vm._v("\n                ขนส่ง\n            ")],1)],1)],1),_c('div',{staticClass:"container-fluid",staticStyle:{"background-color":"white"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }